import { render, staticRenderFns } from "./kiosk-security-restriction.vue?vue&type=template&id=23510f15&scoped=true&"
import script from "./kiosk-security-restriction.vue?vue&type=script&lang=js&"
export * from "./kiosk-security-restriction.vue?vue&type=script&lang=js&"
import style0 from "./kiosk-security-restriction.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./kiosk-security-restriction.vue?vue&type=style&index=1&id=23510f15&scoped=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "23510f15",
  null
  
)

export default component.exports